<template lang="pug">
  app-layout
    v-flex(xs12)
      v-container.py-0.elevation-1.white(fluid)
        v-tabs(slider-color="primary")
          v-tab(v-for="item in items" :key="item.route.name" :to="item.route") 
            span(:class="shouldDisplayTag(item.text)") NEW
            | {{ item.text }}
      v-container(fluid)
        slot
</template>

<script>
export default {
  data() {
    return {
      items: [
        { route: { name: 'reporting' }, text: 'Activity Report' },
        { route: { name: 'reporting.email' }, text: 'Email Reporting' },
        { route: { name: 'reporting.leads-overview' }, text: 'Leads Overview' },
        { route: { name: 'reporting.leads-team' }, text: 'Leads Team Reporting' },
        { route: { name: 'reporting.bulk-actions' }, text: 'Bulk Actions' },
        { route: { name: 'reporting.overview' }, text: 'Summary' },
      ],
    };
  },
  methods: {
    shouldDisplayTag(itemText) {
      if (itemText === 'Activity Report' || itemText === 'Bulk Actions') return 'new-tag--active';
      return 'new-tag--disabled';
    },
  },
};
</script>

<style lang="scss" scoped>
.new-tag {
  &--active {
    margin-right: 4px;
    color: var(--v-primary-base);
    font-size: 9px;
    font-weight: 900 !important;
  }
  &--disabled {
    display: none;
  }
}
</style>
